import React, { Component } from 'react';

import { Breadcrumb, BreadcrumbItem, Modal, ModalBody } from 'reactstrap';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import fbIcon from '../../../images/socialIcons/FBicon.png';
import youtubeIcon from '../../../images/socialIcons/youtubeicon.jpg';
import TwitterIcon from '../../../images/socialIcons/twittericon.png';
import { Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';

import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

import YoutubeStreamForm from './YoutubeStreamForm/YoutubeStreamForm';
import InstagramLogin from 'react-instagram-login';
import './SocialMedia.css';
import $ from 'jquery';
// import {faFolderOpen} from '@fortawesome/fontawesome-free-solid';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import { translate } from 'react-i18next';
import { WOWZA } from '../../../wowza-facebook';
import { faFacebookF, faYoutube, faTwitter } from '@fortawesome/fontawesome-free-brands';
class SocialMedia extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fbEmail: '',
      fbClientId: "231425867421205",
      fbName: '',
      fblogin: false,
      ytEmail: '',
      ytName: '',
      ytlogin: false,
      user: undefined,
      confirmModal: false,
      ytChannelId: '',
      instaLogin: false,
      twitterName: '',
      twitterUserName: '',
      twitterLogin: false,
      sendEmail: '',
      fbChild: [],
      youtubeChild: []

    };

    this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
    this.updateYoutubeLogin = this.updateYoutubeLogin.bind(this);
    this.responseFacebook = this.responseFacebook.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }



  handleFbLoginFailure = (err) => {
    console.log(err);
  }



  componentDidMount=()=>{
    console.log("tes")
    $.ajax({
      method: 'GET',
      url: '/api/v1/social/media',
      success: function (success) {
        let fbchildArray = [];
        let youtubeChildArray = [];
        for (var i = 0; i < success.response.length; i++) {
          let socialMedia = success.response[i];
          if (socialMedia.type === 'FACEBOOK' && !socialMedia.isChild) {
            this.setState({
              fbEmail: socialMedia.email,
              fbName: socialMedia.name,
              fblogin: true
            });
          }
          if (socialMedia.type === 'FACEBOOK' && socialMedia.isChild) {
            fbchildArray.push({
              fbEmail: socialMedia.email,
              fbName: socialMedia.name,
              fblogin: true
            })
          }
          if (socialMedia.type === 'YOUTUBE_EVENT' && !socialMedia.isChild) {
            this.setState({
              ytEmail: socialMedia.email,
              ytName: socialMedia.name,
              ytlogin: true
            });
          }
          if (socialMedia.type === 'YOUTUBE_EVENT' && socialMedia.isChild) {
            youtubeChildArray.push({
              ytEmail: socialMedia.email,
              ytName: socialMedia.name,
              ytlogin: true
            })
          }
          if (socialMedia.type === 'PERISCOPE') {
            this.setState({
              twitterLogin: true,
              twitterName: socialMedia.name,
              twitterUserName: socialMedia.email
            });
          }
        }
        this.setState({
          fbChild: fbchildArray,
          youtubeChild: youtubeChildArray
        });
      }.bind(this),
      error: function (err) {
        console.log(err);
      }.bind(this)
    });
  }

  removeSocialMedia = (type, email) => {
    $.ajax({
      method: 'DELETE',
      url: '/api/v1/social/media?type=' + type+'&email='+email,
      success: function (success) {
        this.setState({
              ytEmail: '',
              ytName: '',
              ytlogin: false
            })
            this.setState({
              fbEmail: "",
              fbName: "",
              fblogin: false
            });
            this.setState({
              fbChild: [],
              youtubeChild: []
            });
        this.componentDidMount();
      this.props.notifySuccess(success.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    })
  }

  handleGoogleLogin = (user) => {
    this.setState({
      user: user.code
    });
    this.addYoutube();
  }

  updateYoutubeLogin(response) {
    this.setState({
      ytEmail: response.email,
      ytName: response.name,
      ytlogin: true
    });
  }

  addYoutube() {
    console.log(this.state.user)
    $.ajax({
      method: 'POST',
      url: '/api/v1/social/media',
      data: JSON.stringify({
        type: 'YOUTUBE_EVENT',
        code: this.state.user
      }),
      success: (success) => {
        this.updateYoutubeLogin(success.response);
        this.props.notifySuccess(success.message);
      },
      error: (err) => {
        this.props.notifyError(err.responseJSON.message);
      }
    });
  }






  toggleModal(e) {
    this.setState({
      modal: !this.state.modal
    });
  }

  toggleConfirmModal() {
    this.setState({
      confirmModal: !this.state.confirmModal
    });
  }

  responseFacebook = (response) => {

    if (!response.id) {
      return;
    }

    $.ajax({
      method: 'GET',
      url: 'https://graph.facebook.com/v3.1/me?fields=accounts&access_token=' + response.accessToken,
      success: (success) => {
        console.log("suceess-->", success)
        if (success.accounts) {
          this.addFacebookAllRecords(success.accounts.data, response)
        } else {
          this.addFacebookAllRecords(null, response)
        }
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

  addFacebookAllRecords = (data, fbResponse) => {
    $.ajax({
      method: 'POST',
      url: '/api/v1/social/media',
      data: JSON.stringify({
        data: data,
        fbResponse: fbResponse,
        type: 'FACEBOOK'
      }),
      success: (success) => {
        console.log("success------>", success)
        if (success) {
          this.componentDidMount();
          this.props.notifySuccess(success.message);
        }
      },
      error: (err) => {
        this.props.notifyError(err.responseJSON.message);
      }
    })
  }

  responseInstagram = (response) => {

    $.ajax({
      type: 'POST',
      url: 'https://api.instagram.com/oauth/access_token',
      data: JSON.stringify({
        client_id: "317109a0810b4b72aaef2226e829d4ef",
        client_secret: "ca7ac865493d4709aea5a2256ef1906d",
        grant_type: 'authorization_code',
        redirect_uri: "http://localhost:3000/dashboard/socialMedia",
        code: response
      }),
      success: (success) => {
        console.log(success)
      },
      error: (err) => {
        console.log(err)
      }
    });
  }

  sendInvitation = () => {
    $.ajax({
      type: 'POST',
      url: '/api/v1/send/invitation',
      data: JSON.stringify({
        host: window.location.hostname == "app.relaystream.io" ? "https://" + window.location.hostname : "http://localhost:3000/",
        email: this.state.sendEmail
      }),
      success: (success) => {
        this.props.notifySuccess(success.message);
      },
      error: (err) => {
        this.props.notifyError(err.responseJSON.message);
      }
    });
  }

  checkEmail = (e) => {
    this.setState({
      sendEmail: e.target.value
    })
  }

  loginTwitter = () => {

    var popup = this.openPopup();
    popup.location = 'https://www.periscope.tv/oauth?response_type=code&client_id=cyUhdpVYI5Gt4Jp6l-qObJku1RNUaaXwNtt4pt5ZmcwkW8ryII&redirect_uri=http://localhost:3000/dashboard/socialMedia';
    this.polling(popup);

  }

  polling = (popup) => {
    const polling = setInterval(() => {
      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(polling);
        // this.props.onFailure(new Error('Popup has been closed by user'));
      }

      const closeDialog = () => {
        clearInterval(polling);
        popup.close();
      };

      try {
        if (!popup.location.hostname.includes('/dashboard/socialMedia/?code') &&
          !popup.location.hostname == '') {
          if (popup.location.search) {
            const query = new URLSearchParams(popup.location.search);
            const code = query.get('code');
            closeDialog();
            return this.getOauthToken(code);
          } else {
            closeDialog();
            return this.props.onFailure(new Error(
              'OAuth redirect has occurred but no query or hash parameters were found. ' +
              'They were either not set during the redirect, or were removed—typically by a ' +
              'routing library—before Twitter react component could read it.'
            ));
          }


        }
      } catch (error) {
        // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
        // A hack to get around same-origin security policy errors in IE.
      }
    }, 500);
  }

  getOauthToken = (code) => {
    $.ajax({
      method: 'POST',
      url: '/api/v1/periscope/token',
      data: JSON.stringify({
        code: code
      }),
      success: function (success) {
        console.log(success)
        this.setState({
          twitterName: success.response.name,
          twitterUserName: success.response.email,
          twitterLogin: true
        })
        this.props.notifySuccess(success.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });

  }

  openPopup = () => {
    const w = 600;
    const h = 400;
    const left = (Screen.width / 2) - (w / 2);
    const top = (Screen.height / 2) - (h / 2);
    return window.open('', '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

  }



  render() {
    const { t } = this.props;
    return (
      <div className="SocialMedia d-flex flex-column flex-grow  pb-3" >
        <div className="SocialMedia__Main">
          <Breadcrumb tag="nav" className="relay-breadcrumb justify-content-end breadcrumb ">
            <BreadcrumbItem tag="a" onClick={() => this.props.history.push('/dashboard')}>{t("Dashboard")}</BreadcrumbItem>
            <BreadcrumbItem active >{t("Social_Media")}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div className="SocialMedia__Main__Listing d-flex flex-column flex-grow">
          <ul className="social-media-list p-0 px-4">
            <li className="social-media-list__item d-flex align-items-center p-2 mb-3">
              <span className="social-media__icon">
                <img src={fbIcon} alt="facebook icon" />
              </span>
              {/* social media's name */}
              <span className="social-media__name mx-2"><h2>Facebook</h2></span>
              {/* account details */}
              <span className="social-media__account flex-grow text-center mx-2">
                <h2 className="social-media__account__ID m-0">{this.state.fbName}</h2>
                <p className="social-media__account__email m-0">{this.state.fbEmail}</p>
              </span>
              {/* login/logout button */}
              <span className="social-media__button ml-2">
                {!this.state.fblogin ? (
                  <FacebookLogin
                    appId={this.state.fbClientId}
                    fields="email,name"
                    scope="user_videos, user_posts, email, publish_video, manage_pages, pages_show_list, publish_pages, public_profile"
                    // scope=" user_videos, user_posts, email, manage_pages,publish_pages"
                    callback={this.responseFacebook}
                    render={renderProps => (
                      <button className="btn btn-sm btn-default px-3 mr-md-2 BTN" onClick={renderProps.onClick}> <FontAwesomeIcon icon={faFacebookF} className="mr-2" /> {t("LOG_IN")}</button>
                    )} />
                )
                  : (<button onClick={() => this.removeSocialMedia("FACEBOOK", this.state.fbEmail)} className="btn btn-sm btn-default px-3 mr-md-2 ">
                    {t("Log_Out")} </button>)
                }
              </span>
            </li>
            {this.state.fbChild.map((item) => {
              return (<li className="social-media-list__item d-flex align-items-center p-2 mb-3 child">
                <span className="social-media__icon">
                  <img src={fbIcon} alt="facebook icon" />
                </span>
                {/* social media's name */}
                <span className="social-media__name mx-2"><h2>Facebook</h2></span>
                {/* account details */}
                <span className="social-media__account flex-grow text-center mx-2">
                  <h2 className="social-media__account__ID m-0">{item.fbName}</h2>
                  <p className="social-media__account__email m-0">{item.fbEmail}</p>
                </span>
                {/* login/logout button */}
                <span className="social-media__button ml-2">
                  <button onClick={() => this.removeSocialMedia("FACEBOOK",item.fbEmail)} className="btn btn-sm btn-default px-3 mr-md-2 ">
                    {t("Log_Out")} </button>
                </span>
              </li>)
            })}
            <li className="social-media-list__item d-flex align-items-center p-2 mb-3">
              <span className="social-media__icon">
                <img src={youtubeIcon} alt="youtube icon" />
              </span>
              <span className="social-media__name mx-2">
                <h2>Youtube</h2>
              </span>
              <span className="social-media__account flex-grow text-center mx-2">
                <h2 className="social-media__account__ID m-0">{this.state.ytName}</h2>
                <p className="social-media__account__email m-0">{this.state.ytEmail}</p>
              </span>
              <span className="social-media__button ml-2">
                {
                  !this.state.ytlogin ? (
                    <GoogleLogin
                      apiKey="AIzaSyALq2_28Zao2NGfuCN3Pm8IL9NFmUEufxc"
                      clientId="843586925977-d7j31p5j0me5kqvcp29nr9s37reg5b5u.apps.googleusercontent.com"
                      client_secret="B5eY8pc_okwGIRJyMWPMbhEu"
                      scope="https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly"
                      discoveryDocs='https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'
                      approval_prompt='force'
                      responseType='code'
                      render={renderProps => (
                        <button type="button" className="btn btn-sm btn-default px-3 mr-md-2 BTN" onClick={renderProps.onClick}><FontAwesomeIcon icon={faYoutube} className="mr-2" /> {t("LOG_IN")}</button>
                      )}
                      onSuccess={this.handleGoogleLogin}
                    />
                  )
                    :
                    (<button onClick={() => this.removeSocialMedia('YOUTUBE_EVENT', this.state.ytEmail)} className="btn btn-sm btn-default px-3 mr-md-2 ">
                      {t("Log_Out")}
                    </button>)
                }
              </span>
            </li>
            {this.state.youtubeChild.map((item) => {
              return (<li className="social-media-list__item d-flex align-items-center p-2 mb-3 child">
                <span className="social-media__icon">
                  <img src={youtubeIcon} alt="youtube icon" />
                </span>
                <span className="social-media__name mx-2">
                  <h2>Youtube</h2>
                </span>
                <span className="social-media__account flex-grow text-center mx-2">
                  <h2 className="social-media__account__ID m-0">{item.ytName}</h2>
                  <p className="social-media__account__email m-0">{item.ytEmail}</p>
                </span>
                <span className="social-media__button ml-2">
                  <button onClick={() => this.removeSocialMedia('YOUTUBE_EVENT',item.ytEmail)} className="btn btn-sm btn-default px-3 mr-md-2 ">
                    {t("Log_Out")}
                  </button>
                </span>
              </li>)
            })}

            {/* ------ */}

            {/* <li className="social-media-list__item d-flex align-items-center p-2 mb-3">
              <span className="social-media__icon">
                <img src={TwitterIcon} alt="Twitter icon" />
              </span>
              <span className="social-media__name mx-2">
                <h2>Twitter</h2>
              </span>
              <span className="social-media__account flex-grow text-center mx-2">
                <h2 className="social-media__account__ID m-0">{this.state.twitterName}</h2>
                <p className="social-media__account__email m-0">{this.state.twitterUserName}</p>
              </span>
              <span className="social-media__button ml-2">
              {
                  !this.state.fblogin ? (
                    <FacebookLogin
                      appId="231425867421205"
                      // fields="likes, videos, email,name"
                      fields="email,name"
                      scope="user_videos, user_posts, email, publish_video, manage_pages, pages_show_list, publish_pages, public_profile"
  
                      // scope=" user_videos, user_posts, email, manage_pages,publish_pages"
                      callback={this.responseFacebook}
                      render={renderProps => (
                        <button className="btn btn-sm btn-default px-3 mr-md-2 BTN" onClick={renderProps.onClick}> <FontAwesomeIcon icon={faFacebookF} className="mr-2" /> {t("LOG_IN")}</button>
                      )} />
                  )
                    : (<button onClick={() => this.removeSocialMedia('FACEBOOK')} className="btn btn-sm btn-default px-3 mr-md-2 ">
                      {t("Log_Out")} </button>)
                  
              }
              </span>
            </li> */}


            {/* <li className="social-media-list__item d-flex align-items-center p-2 mb-3">
              <span className="social-media__icon">
                <img src={TwitterIcon} alt="Twitter icon" />
              </span>
              <span className="social-media__name mx-2">
                <h2>Instagram</h2>
              </span>
              <span className="social-media__account flex-grow text-center mx-2">
                <h2 className="social-media__account__ID m-0">{this.state.ytName}</h2>
                <p className="social-media__account__email m-0">{this.state.ytEmail}</p>
              </span>
              <span className="social-media__button ml-2">
                {
                  !this.state.instaLogin ? (
                    <InstagramLogin
                      clientId="317109a0810b4b72aaef2226e829d4ef"
                      scope="basic+public_content+comments+likes+follower_list"
                      buttonText="Login"
                      render={renderProps => (
                        <button type="button" className="btn btn-sm btn-default px-3 mr-md-2 BTN" onClick={renderProps.onClick}><FontAwesomeIcon icon={faTwitter} className="mr-2" /> {t("LOG_IN")}</button>
                      )}
                      onSuccess={this.responseInstagram}
                    />
                  )
                    :
                    (<button onClick={() => this.removeSocialMedia('YOUTUBE_EVENT')} className="btn btn-sm btn-default px-3 mr-md-2 ">
                      {t("Log_Out")}
                    </button>)
                }
              </span>
            </li> */}

          </ul>
        </div>
        <Modal className="youtubeStreamModal" isOpen={this.state.modal} toggle={this.toggleModal} >
          <ModalBody>
            <YoutubeStreamForm t={t} toggleModal={this.toggleModal} notifySuccess={this.props.notifySuccess} notifyError={this.props.notifyError} user={this.state.user} updateYoutubeLogin={this.updateYoutubeLogin} />
          </ModalBody>
        </Modal>
        <span className="send-label">
          Enter email and send invitation to your firend
          </span>
        <div className="d-flex flex column send-field">
          <InputGroup>
            <Input className="mr-1" type="text" name="send" id="send" onChange={this.checkEmail} value={this.state.sendEmail} />
            <InputGroupAddon addonType="append">
              <button title="Submit URL" className="btn btn-secondary send-button"
                onClick={this.sendInvitation}>Send</button>
            </InputGroupAddon>
          </InputGroup>
        </div>

        <ConfirmDialog
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal}
          confirm={this.confirmDelete} />
      </div>
    );
  }
}

export default translate('translations')(SocialMedia);



// WEBPACK FOOTER //
// ./src/components/DashboardPage/SocialMedia/SocialMedia.js